"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroResultsContainer = exports.DidYouMeanMessageForZeroResultComponent = exports.ZeroSearchResultsComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const ReactDOM = require("react-dom");
const Spinner_1 = require("Views/Shared/Components/Spinner/Spinner");
const DidYouMean_1 = require("../DidYouMean");
const ZeroSearchResults_1 = require("../ZeroSearchResults");
const ZeroSearchResultsComponent = ({ title, className, waitingForResults, recommendations, suggestions, selectedFiltersQueryString, }) => ((0, jsx_runtime_1.jsx)("div", { className: className, children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: waitingForResults ? ((0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper h-screen", children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { visible: true, className: "spinner fixed" }) })) : ((0, jsx_runtime_1.jsx)("div", { className: "container-px", children: (0, jsx_runtime_1.jsx)(ZeroSearchResults_1.ZeroSearchResults, { title: title, recommendations: recommendations, centerBlock: true, suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString }) })) }) }));
exports.ZeroSearchResultsComponent = ZeroSearchResultsComponent;
const zeroResultsContentSelector = '#zero-results__content';
const DidYouMeanMessageForZeroResultComponent = ({ suggestions, selectedFiltersQueryString }) => {
    const didYouMean = React.useMemo(() => {
        const firstItem = $(zeroResultsContentSelector).find('.column, .prose.prose-danfoss').first();
        let didYouMeanContainer;
        if (firstItem && firstItem.length > 0) {
            const alignedDidYouMeanContainer = $(zeroResultsContentSelector).find('#alignedDidYouMeanContainer');
            if (alignedDidYouMeanContainer && alignedDidYouMeanContainer.length !== 0) {
                didYouMeanContainer = alignedDidYouMeanContainer.get(0);
            }
            else {
                const container = $('<div id="alignedDidYouMeanContainer"></div>');
                firstItem.prepend(container);
                didYouMeanContainer = container.get(0);
            }
        }
        else {
            didYouMeanContainer = $('#didYouMeanAlternateContainer').get(0);
        }
        return didYouMeanContainer;
    }, []);
    if (!suggestions)
        return null;
    return ReactDOM.createPortal((0, jsx_runtime_1.jsx)(DidYouMean_1.DidYouMean, { suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString }), didYouMean);
};
exports.DidYouMeanMessageForZeroResultComponent = DidYouMeanMessageForZeroResultComponent;
const ZeroResultsContainer = ({ additionalData, className, suggestions, selectedFiltersQueryString, waitingForResults, }) => {
    (0, app_1.hideBreadcrumbsInsideList)();
    if (additionalData.zeroResultsTitle && additionalData.zeroResultsText) {
        return ((0, jsx_runtime_1.jsx)(exports.ZeroSearchResultsComponent, { title: additionalData.zeroResultsTitle, recommendations: additionalData.zeroResultsText, className: className, suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString, waitingForResults: waitingForResults }));
    }
    else {
        if (additionalData.contentPage) {
            additionalData.contentPage.style.dispay = 'none';
        }
        return ((0, jsx_runtime_1.jsx)(exports.DidYouMeanMessageForZeroResultComponent, { suggestions: suggestions, selectedFiltersQueryString: selectedFiltersQueryString }));
    }
};
exports.ZeroResultsContainer = ZeroResultsContainer;
